<template>
  <div id="app">
    <!-- 你的应用内容 -->
    <router-view />
  </div>
</template>
